var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogowithoutname(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 65,
    viewBox: "0 0 69 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7533 27.3102C30.6649 28.0093 35.0045 26.7433 38.7721 23.5121C39.2469 23.106 38.9456 22.7685 38.8484 22.2842C34.8158 25.8439 30.2092 27.1748 24.9792 26.3073C24.9716 27.1405 25.0116 27.2053 25.7533 27.3102Z",
    fill: "#752EDC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_414_3300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0949 43.0801C17.2138 42.3699 17.4991 41.698 17.9276 41.1194C18.3561 40.5407 18.9156 40.0718 19.5603 39.751C20.8492 39.0799 22.2296 38.9216 23.652 38.9674C23.7912 38.5079 23.9094 38.0598 24.0619 37.6327C24.6602 35.9295 25.5414 34.3393 26.6683 32.929C26.8438 32.929 27.0173 32.929 27.1908 32.9175C32.3083 32.7268 37.0178 31.2816 41.1324 28.1623C41.3529 27.9919 41.5636 27.8092 41.7635 27.6151C42.5915 28.08 43.3565 28.649 44.0401 29.3082C44.2559 29.4835 44.4482 29.686 44.6121 29.9107C44.9724 30.498 45.5254 30.6314 46.1526 30.7439C49.3578 31.3159 52.4675 32.193 55.2589 33.9433C56.5841 34.7727 57.7223 35.7985 58.4564 37.2113C58.5251 37.3448 58.5784 37.4859 58.6185 37.5755C57.4173 37.3582 56.218 37.0874 55.0053 36.933C52.7329 36.6722 50.4356 36.7191 48.1756 37.0722C47.779 37.1294 47.3825 37.1942 46.9878 37.2628C46.1526 37.3925 45.3461 37.5088 44.7989 38.3172C44.5587 38.6719 44.061 38.853 43.6778 39.1161C44.8103 39.9627 45.9658 40.7883 47.0736 41.6558C50.4839 44.283 53.7023 47.1503 56.7042 50.2358C60.7989 45.6096 63.3463 39.8199 63.9907 33.6755C64.635 27.5311 63.3441 21.3389 60.2983 15.9638C57.2525 10.5888 52.6038 6.29925 47.0017 3.69451C41.3995 1.08976 35.1237 0.299865 29.0508 1.43515C22.9779 2.57044 17.4113 5.57421 13.1285 10.0269C8.84573 14.4796 6.06065 20.1588 5.16234 26.2712C4.26402 32.3836 5.29732 38.624 8.1179 44.1206C10.9385 49.6172 15.4055 54.0956 20.8949 56.9302C19.3963 53.6679 18.0635 50.3426 17.3275 46.8076C17.072 45.5721 16.8471 44.3309 17.0949 43.0801ZM19.5336 11.048C19.7018 10.9183 19.8775 10.7986 20.0598 10.6895C23.2897 8.78283 26.8209 7.7151 30.4645 7.01535C32.0286 6.73102 33.6132 6.57479 35.2026 6.54821C36.5373 6.51198 36.6727 6.77129 36.7813 8.04876C37.0216 10.8783 37.197 13.7154 37.5612 16.5297C37.8071 18.4363 38.3238 20.2915 38.7319 22.1906C39.4011 22.1143 39.9026 22.0285 40.4059 21.9999C40.9349 21.9696 41.4654 21.9824 41.9923 22.038C43.245 22.1906 43.6816 23.0028 42.978 24.0496C42.4741 24.8082 41.8508 25.4804 41.1324 26.0401C37.0178 29.1595 32.3083 30.6009 27.1908 30.7935C25.551 30.8564 23.9132 30.7668 22.3917 30.0499C21.1466 29.4626 21.0055 28.5398 22.0904 27.7161C22.801 27.2174 23.5553 26.784 24.3441 26.4215C24.6797 26.2537 24.7807 26.0954 24.6682 25.7408C24.3994 24.8923 24.1935 24.0248 23.8941 23.182C22.6357 19.6547 20.8148 16.3943 19.076 13.0938C18.4887 11.986 18.5001 11.8221 19.5336 11.0461V11.048Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2221 33.2913C39.2221 32.9214 38.3432 32.6221 37.2583 32.6221C36.5517 32.6485 35.8684 32.8812 35.2925 33.2913C35.8684 33.7014 36.5517 33.9341 37.2583 33.9606C38.3432 33.9606 39.2221 33.6612 39.2221 33.2913Z",
    fill: "#4DD4CB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_414_3300",
    x: 0.847168,
    y: 0.930176,
    width: 67.3052,
    height: 63.9995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_414_3300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_414_3300",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowithoutname);
export default __webpack_public_path__ + "static/media/logowithoutname.132bb06dea3dd5c0f0b8071f4b16acba.svg";
export { ForwardRef as ReactComponent };